package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesRightSidebar : StyleSheet() {

    val ticketSidebar by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
    }

    val sidebarSectionDimmed by style { opacity(0.82) }
    val sidebarContentDimmed by style { opacity(0.92) }

    // ---------- Card Documents (sous Contexte) ----------
    val documentsCard by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
    }

    val documentItem by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
        padding(8.px, 10.px)
        borderRadius(8.px)
        property("transition", "background-color 140ms ease")
        property("cursor", "pointer")
        property("text-decoration", "none")
        color(Color("rgba(15,23,42,0.88)"))
        self + hover style {
            backgroundColor(Color("rgba(15,23,42,0.04)"))
        }
    }

    /** Row qui encapsule uniquement les icônes : pas de gap interne, le gap du parent s’applique après. */
    val documentItemIconsRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        gap(0.px)
        flexShrink(0)
    }

    /** Groupe icône direction + icône doc : collés (gap 0). */
    val documentIconsGroup by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(0.px)
        flexShrink(0)
    }

    /** Icône direction reçu (⬇) / envoyé (⬆) : Appsyde doux, largeur réduite. */
    val documentDirectionIcon by style {
        fontSize(14.px)
        flexShrink(0)
        width(5.px)
        property("text-align", "center")
        property("line-height", "1")
        color(Color("rgba(102,96,230,0.55)"))
    }

    val documentIcon by style {
        fontSize(18.px)
        flexShrink(0)
        width(28.px)
        property("text-align", "center")
    }

    val documentTitle by style {
        flex(1)
        overflow("hidden")
        property("text-overflow", "ellipsis")
        property("white-space", "nowrap")
        fontSize(13.px)
        fontWeight(600)
    }

    val documentDate by style {
        fontSize(11.px)
        color(Color("rgba(15,23,42,0.5)"))
        flexShrink(0)
    }
}
